<template>
  <div class="main-page">
    <div class="left">
      <auth-button code="TBZZJG" @click="sync" type="primary" class="addBtn iconfont icon-jiahao">同步组织架构</auth-button>
      <org-tree @select-node="handleSelectDept"></org-tree>
    </div>
    <div class="right">
      <el-form @submit.native.prevent :inline="true">
        <!-- <el-form-item label="部门">
          <span style="display: block; width: 150px; overflow: hidden"
          ><el-tag size="midium" type="info">{{ selectDept ? selectDept.departmentName : "所有部门" }}</el-tag></span
          >
        </el-form-item> -->
        <el-form-item>
          <el-input @keyup.native.enter.stop="onSearch()" class="search-input" v-model.trim="keyWords" placeholder="请输入姓名或手机号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch" icon="el-icon-search">查询</el-button>
          <el-button type="primary" plain class="iconfont icon-reset" @click="reset"> 重置</el-button>
        </el-form-item>
      </el-form>
      <!-- <div style="padding-left: 10px" v-if="departLeader && departLeader.length">
        {{ selectDept.departmentName }}部门主管：{{ departLeader && departLeader.map(d => d.leaderName).join(",") }}
      </div> -->
      <div class="list-table">
        <new-table :data="tableData" :columns="columns" :pages="pages"></new-table>
      </div>
    </div>
    <role-list ref="roleList" :selectedUser="selectedUser" :show.sync="showSelector"></role-list>
  </div>
</template>

<script>
import NewTable from "../../components/new-table.vue";
import OrgTree from "./components/org-tree.vue";
import orgApi from "@/apis/org";
import RoleList from "./components/role-list.vue";
import CacheService from "../../service/catch";

export default {
  components: { OrgTree, NewTable, RoleList },
  data() {
    return {
      departLeader: "",
      showSelector: false,
      selectDept: null,
      selectedUser: null,
      keyWords: "",
      tableData: [],
      columns: [
        {
          label: "员工姓名",
          prop: "realName",
          render: (h, scope) => {
            return (
              <div>
                <span>{scope.row.realName}</span>
                <span class="leader-css" v-show={scope.row.isLeader}>
                  主管
                </span>
              </div>
            );
          },
        },
        { label: "手机号", prop: "phone" },
        {
          label: "所属部门",
          prop: "departmentName",
          render: (h, scope) => {
            return <span>{(scope.row.departmentList && scope.row.departmentList.map((d) => d.departmentName).join(",")) || "总公司"}</span>;
          },
        },
        {
          label: "角色",
          prop: "departmentName",
          render: (h, scope) => {
            let roleList = scope.row.roleList.map((r) => {
              return (
                <el-tag class="text-ellipsis" style={{ marginRight: "5px", maxWidth: "95%" }}>
                  {r.roleName}
                </el-tag>
              );
            });
            return roleList;
          },
        },
        {
          label: "操作",
          render: (h, scope) => {
            return (
              <auth-button type="text" code="FPJS" onClick={() => this.role(scope.row)}>
                分配角色
              </auth-button>
            );
          },
        },
      ],
      pages: {
        props: {
          "page-size": 20,
          "current-page": 1,
          total: 0,
        },
        on: {
          "current-change": (p) => {
            this.currentChange(p);
          },
          "size-change": this.sizeChange,
        },
      },
      times: 0,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    sync() {
      this.times = 0;
      orgApi.syncCompInfo().then((res) => {
        this.syncData();
      });
    },
    syncData() {
      orgApi.CheckSyncDataIsComplete().then((res) => {
        console.log(res);
        if (res) {
          this.$axios.get(`/Crm/Department/DepartmentByUId?userId=${this.$store.state.user.userID}`).then((_res) => {
            let obj = CacheService.get("user");
            obj.departmentList = _res;
            this.$store.commit("initUser", obj);
            window.location.reload();
          });
        } else {
          if (this.times > 3) {
            this.$message.warning("同步失败！");
          } else {
            setTimeout(() => {
              this.times += 1;
              this.syncData();
            }, 5000);
          }
        }
      });
    },
    edit(data, e) {
      console.log(data);
      console.log(e);
    },
    role(data) {
      this.selectedUser = data;
      this.showSelector = true;
    },
    getData() {
      let deptId = this.selectDept ? this.selectDept.id : -1;
      const param = {
        deptId: deptId ? deptId : -1,
        keyWords: this.keyWords,
        page: this.pages.props["current-page"],
        pageSize: this.pages.props["page-size"],
      };
      orgApi.getCompUserList(param).then((res) => {
        this.tableData = res.data;
        this.pages.props.total = res.dataCount;
      });
    },
    currentChange(p) {
      this.pages.props["current-page"] = p;
      this.getData();
    },
    sizeChange(size) {
      this.pages.props["page-size"] = size;
      this.currentChange(1);
    },
    handleSelectDept(d) {
      this.selectDept = d;
      // if (d.id) {
      //   this.$axios.get(`/Department/DepartmentInfo?DepartmentId=${d.id}`).then(res=>{
      //     this.departLeader = res;
      //   })
      // }else{
      //   this.departLeader =""
      // }
      this.currentChange(1);
    },
    onSearch() {
      this.currentChange(1);
    },
    reset() {
      this.keyWords = "";
      this.currentChange(1);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .leader-css {
  background-color: #ff9224;
  color: #ffffff;
  margin-left: 5px;
  padding: 0 3px;
  border-radius: 3px;
}
.main-page {
  display: flex;
  height: 0;
  padding-bottom: 20px !important;

  .left {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    border: 1px solid #ebedf3;
    flex: 0 0 220px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .addBtn {
      border-radius: 5px;
      height: 38px;
      margin: 20px 20px 10px;
    }
  }

  .right {
    background-color: #fff;
    flex: 1;
    display: flex;
    flex-direction: column;
    border: 1px solid #ebedf3;
    border-left: none;
    padding: 20px;
    box-sizing: border-box;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
}
</style>
